export default __webpack_public_path__ + "static/media/infos_structure.3ea96f5b.svg";